import "./inline.css.ts.vanilla.css-mistica.js";
var v = "kkfbnv2 kkfbnv1", n = {
    between: "kkfbnv5",
    around: "kkfbnv6",
    evenly: "kkfbnv7"
}, a = "kkfbnv4 kkfbnv1", f = {
    space: "var(--kkfbnv0)"
}, r = "kkfbnv3 kkfbnv1";
export { v as fullWidth, n as justifyVariants, a as noFullWidth, f as vars, r as wrap };
